// import { HorseAccessService } from '@pingum/api-services';
import HorseService from '../../services/HorseService';
import BarnService from '../../services/BarnService';
import * as types from './types';
import {
  dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch,
} from '../networkDispatcher';

export const getHorseAccessForBarnAndType = (barnId, type) => (dispatch) => {
  const promise = BarnService.getBarnHorseAccessUsersByType(barnId, type);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_HORSE_ACCESS_BY_TYPE_REQUESTED,
    successType: types.GET_HORSE_ACCESS_BY_TYPE_SUCCESS,
    errorType: types.GET_HORSE_ACCESS_BY_TYPE_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading horse access for this Questri Barn and access type',
    responseName: 'horseAccessForBarnAndType',
  });
  return promise;
};

export const getHorseAccess = (horseId, page = 0, pageSize = 25, sort = '', search = '') => (dispatch) => {
  const promise = HorseService.getHorseAccess(horseId, page, pageSize, sort, search);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_HORSE_ACCESS_REQUESTED,
    successType: types.GET_HORSE_ACCESS_SUCCESS,
    errorType: types.GET_HORSE_ACCESS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading horse access for this horse',
    responseName: 'horseAccess',
  });
  return promise;
};

export const addHorseAccess = (horseId, barnUserId, request) => (dispatch) => {
  const promise = HorseService.addHorseAccess(horseId, barnUserId, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ADD_HORSE_ACCESS_REQUESTED,
    successType: types.ADD_HORSE_ACCESS_SUCCESS,
    errorType: types.ADD_HORSE_ACCESS_ERROR,
    promise,
    successMessage: 'Successfully created the horse access',
    defaultErrorMessage: 'There was a problem adding the horse access to the organization',
    responseName: 'newHorseAccess',
  });
  return promise;
};

export const updateHorseAccess = (horseId, barnUserId, request) => (dispatch) => {
  const promise = HorseService.updateHorseAccess(horseId, barnUserId, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_HORSE_ACCESS_REQUESTED,
    successType: types.UPDATE_HORSE_ACCESS_SUCCESS,
    errorType: types.UPDATE_HORSE_ACCESS_ERROR,
    promise,
    successMessage: 'Successfully updated the horse access',
    defaultErrorMessage: 'There was a problem updating the horse access',
    responseName: 'updatedHorseAccess',
  });
  return promise;
};

export const deleteHorseAccess = (id) => (dispatch) => {
  const promise = HorseService.deleteHorseAccess(id);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.DELETE_HORSE_ACCESS_REQUESTED,
    successDispatch: {
      type: types.DELETE_HORSE_ACCESS_SUCCESS,
      deletedHorseAccessId: id,
    },
    errorType: types.DELETE_HORSE_ACCESS_ERROR,
    promise,
    successMessage: 'Successfully deleted the horse access',
    defaultErrorMessage: 'There was a problem deleting the horse access',
    responseName: 'response',
  });
  return promise;
};

export const deleteHorseAccessForHorse = (id) => (dispatch) => {
  const promise = HorseService.deleteHorseAccessForHorse(id);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.DELETE_HORSE_ACCESS_FOR_HORSE_REQUESTED,
    successDispatch: {
      type: types.DELETE_HORSE_ACCESS_FOR_HORSE_SUCCESS,
      deletedHorseAccessId: id,
    },
    errorType: types.DELETE_HORSE_ACCESS_FOR_HORSE_ERROR,
    promise,
    successMessage: 'Successfully deleted the horse access',
    defaultErrorMessage: 'There was a problem deleting the horse access',
    responseName: 'response',
  });
  return promise;
};
